import React from "react";
import { useWorkspace } from "../../context/WorkspaceRegionProvider";
import CnDetail from "../detail";
import IntlDetail from "../intl/Detail";

const WorkspaceDetail = () => {
  const { workspace } = useWorkspace();

  if (workspace === "intl") {
    return <IntlDetail key={workspace} />;
  }

  return <CnDetail key={workspace} />;
};

export default WorkspaceDetail;
